import BaseCadastro from "components/BaseCadastro";
import { Label } from "components/input/Label";
import FamiliaProduto from "model/administracao/cadastro/produto/FamiliaProduto";
import OrigemProduto from "model/administracao/cadastro/produto/OrigemProduto";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { useEffect, useRef, useState } from "react";
import "react-hook-form";
import { Controller, useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import FamiliaProdutoService from "service/administracao/cadastro/produto/FamiliaProdutoService";

const familiaService = new FamiliaProdutoService();

export default function FamiliaProdutoCadastro() {

    const [queryParameters] = useSearchParams();

    const {control, clearErrors, setError, setFocus, register, formState: {errors}} = useForm();

    const [familia, setFamilia] = useState<FamiliaProduto>(new FamiliaProduto());
    const [titulo, setTitulo] = useState<string>('Família');
    const [origens, setOrigens] = useState<OrigemProduto[]>([]);
    const [editando, setEditando] = useState<boolean>(false);

    const inputNomeRef = useRef<any>(null);

    useEffect(() => {
        if (!window.location.pathname.includes("cadastrar")) {
            setEditando(true);
        }
        familiaService.origens().then(lista => {
            setOrigens(lista);
        }).catch(err => {
            console.log(err);
        });
    }, []);

    function validar() {

        if(!familia.codigo){
            setError("codigo", {type: "manual", message: "Código é Obrigatório"}, {shouldFocus: true})
            return false;
        }
        if (!familia.nome) {
            setError("nome", {type: "manual", message: "Nome é Obrigatório"}, {shouldFocus: true})
            return false;
        }
        if (!familia.origemProduto) {
            setError("origemProduto", {type: "manual", message: "Origem é Obrigatória"}, {shouldFocus: true})
            return false;
        }
        return true;
    }

    const codigoKeyDown = (e: any) => {
        if (e.key === 'Enter') {
            if (!familia.codigo) {
                familiaService.proximoCodigo().then((data) => {
                    setFamilia({...familia, codigo: data});
                    setFocus("nome");
                    clearErrors("codigo");
                }).catch((error) => {
                    console.log(error);
                });
            }
        }
    }

    return (

        <BaseCadastro model={familia} service={familiaService} setModel={(value: FamiliaProduto) => setFamilia(value)} novoCadastro getNewModel={() => new FamiliaProduto()} 
           validar={() => validar()} urlService="/familiaProduto" pathCadastro="/familiaProduto" tituloPagina={'Familia'}>

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Código</Label>
                <div className="col-sm-12">
                    <InputText 
                        disabled={editando} 
                        className={errors.codigo ? "p-invalid" : ""}
                        required value={familia.codigo||""} 
                        onKeyDown={codigoKeyDown} 
                        style={{ width: '100%' }} 
                        {...register("codigo", {
                            onChange: (e) => {
                                setFamilia({ ...familia, codigo: e.target.value })
                                clearErrors("codigo")
                            } 
                        })}
                    />
                </div>
                {errors.codigo && errors.codigo.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.codigo?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Nome</Label>
                <div className="col-sm-12">
                    <InputText
                        className={errors.nome ? "p-invalid" : ""}
                        required value={familia.nome}
                        style={{ width: '100%' }}
                        {...register("nome", {
                            onChange: (e) => {
                                setFamilia({ ...familia, nome: e.target.value })
                                clearErrors("nome")
                            }
                        })}
                    />
                </div>
                {errors.nome && errors.nome.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.nome?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Origem</Label>
                <div className="col-sm-12">
                    <Controller name="origemProduto" control={control} render={({field}) => (
                        <Dropdown 
                            focusInputRef={field.ref}
                            value={familia.origemProduto} 
                            className={errors.origemProduto ? "p-invalid" : ""}
                            options={origens} 
                            optionLabel="nome" 
                            onChange={(e) => {
                                clearErrors("origemProduto")
                                setFamilia({ ...familia, origemProduto: e.value })
                            }}
                            style={{ width: '100%' }} 
                        />
                    )}/>
                </div>
                {errors.origemProduto && errors.origemProduto.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.origemProduto?.message as string}</span> : null}
            </div>



        </BaseCadastro>
    )
}
